import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import * as Icon from 'react-bootstrap-icons';

function PaymentError({ message = 'Unknown error', onRetry }) {
  return (
    <div className="confirmation text-center js-payment-result" data-error={message}>
      <Icon.XCircleFill size={48} color="#b83116" data-testid="icon-x-circle-fill" />
      <p className="text-danger mt-3 text-weight--normal">
        Sorry, your payment has been declined for the following reason
      </p>
      <p className="text-sm margin-bottom">{message}</p>
      {onRetry && (
        <Button bsStyle="default" onClick={onRetry}>
          Retry
        </Button>
      )}
    </div>
  );
}

PaymentError.propTypes = {
  message: PropTypes.string,
  onRetry: PropTypes.func,
};

export default PaymentError;
